<script lang="ts">
  // Thin wrapper over the .tym-badge--* vocabulary (app.css) — callers pick a
  // `kind`, we pick the class. No color decisions live in call sites.
  export type BadgeKind =
    | 'pending'
    | 'approved'
    | 'rejected'
    | 'logged'
    | 'info'
    | 'danger'
    | 'alert'
    | 'role-employee'
    | 'role-hr'
    | 'role-admin';

  const { kind, label }: { kind: BadgeKind; label: string } = $props();
</script>

<span class="tym-badge tym-badge--{kind}">{label}</span>
